/**
 * Phone number formating methods
 */
export const PHONE = {

  /**
   * Format a belgian phone number
   *
   * @see https://en.wikipedia.org/wiki/Telephone_numbers_in_Belgium
   *
   * @param {string} value Phone number to format
   *
   * @returns string
   *
   * @todo Add parameter for separator management
   */
  BE: (value) => {
    // Remove white spaces && international prefixe
    let phone = value.replace(/\s|\+32|0032/g, '');

    // Remove initial 0 if present
    if (phone.slice(0, 1) === '0') {
      phone = phone.slice(1);
    }

    // Landline phone number
    if (phone.length === 8) {
      // Premium pay rate services
      if ([/7[078]/g].some(regex => regex.test(phone.slice(0, 3)))) {
        return `+32 ${phone.slice(0, 2)} ${phone.slice(2, 5)} ${phone.slice(5, 8)}`;
      }

      // Free and pay services
      if ([/800/g, /90[012345679]/g].some(regex => regex.test(phone.slice(0, 3)))) {
        return `+32 ${phone.slice(0, 3)} ${phone.slice(3, 5)} ${phone.slice(5, 8)}`;
      }

      // Absolutely basic landline phone number
      const prefix = phone.slice(0, 1);
      switch (prefix) {
        case '2':
        case '3':
        case '4':
        case '9':
          return `+32 ${phone.slice(0, 1)} ${phone.slice(1, 4)} ${phone.slice(4, 6)} ${phone.slice(6, 8)}`;
        default:
          return `+32 ${phone.slice(0, 2)} ${phone.slice(2, 4)} ${phone.slice(4, 6)} ${phone.slice(6, 8)}`;
      }
    }

    // Mobile phone number
    if (phone.length === 9) {
      return `+32 ${phone.slice(0, 3)} ${phone.slice(3, 5)} ${phone.slice(5, 7)} ${phone.slice(7, 9)}`;
    }

    return value;
  },
};
